export const repositories = "users/akutuzova11/repos";
